import { apiSlice } from '../../api';
import type {
  CancelTransactionDTO,
  CancelTransactionResult,
  ExecuteTransactionDTO,
  ExecuteTransactionResult,
  GetUsersDTO,
  GetUsersResult,
  DeleteUserDTO,
  CreateUserDTO,
  CreateUserResult,
  DeleteUserResult,
  GetMyAuthoritiesResult,
  GetMyAuthoritiesDTO,
  GetRolesDTO,
  GetRolesResult,
  CreateRoleDTO,
  CreateRoleResult,
  GetAuthoritiesDTO,
  GetAuthoritiesResult,
  DeleteRoleDTO,
  DeleteRoleResult,
  GetRoleByIdResult,
  GetRoleByIdDTO,
  UpdateRoleDTO,
  UpdateRoleResult,
  UpdateUserResult,
  UpdateUserDTO,
} from './types';

export const adminRolesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getMyAuthorities: build.query<GetMyAuthoritiesResult, GetMyAuthoritiesDTO>({
        query: () => {
          return {
            url: '/admin/v1/my-authorities',
            method: 'GET',
          };
        },
      }),
      getAuthorities: build.query<GetAuthoritiesResult, GetAuthoritiesDTO>({
        query: () => {
          return {
            url: '/admin/v1/authorities',
            method: 'GET',
          };
        },
      }),

      getUsers: build.query<GetUsersResult, GetUsersDTO>({
        query: () => {
          return {
            url: '/admin/v1/users',
            method: 'GET',
          };
        },
      }),

      getRoles: build.query<GetRolesResult, GetRolesDTO>({
        query: () => {
          return {
            url: '/admin/v1/roles',
            method: 'GET',
          };
        },
      }),

      getRoleById: build.query<GetRoleByIdResult, GetRoleByIdDTO>({
        query: ({ roleId }) => {
          return {
            url: `/admin/v1/roles/${roleId}`,
            method: 'GET',
          };
        },
      }),

      updateRole: build.mutation<UpdateRoleResult, UpdateRoleDTO>({
        query: ({ roleId, body }) => {
          return {
            url: `/admin/v1/roles/${roleId}`,
            method: 'PUT',
            body,
          };
        },
      }),

      deleteUser: build.mutation<DeleteUserResult, DeleteUserDTO>({
        query: ({ userUid, roleId }) => {
          return {
            url: `/admin/v1/users/${userUid}/roles/${roleId}`,
            method: 'DELETE',
          };
        },
      }),

      deleteRole: build.mutation<DeleteRoleResult, DeleteRoleDTO>({
        query: ({ roleId }) => {
          return {
            url: `/admin/v1/roles/${roleId}`,
            method: 'DELETE',
          };
        },
      }),

      createUser: build.mutation<CreateUserResult, CreateUserDTO>({
        query: (body) => {
          return {
            url: '/admin/v1/user-roles',
            method: 'POST',
            body,
          };
        },
      }),

      updateUser: build.mutation<UpdateUserResult, UpdateUserDTO>({
        query: ({ userUid, roleId }) => {
          return {
            url: `/admin/v1/users/${userUid}/roles/${roleId}`,
            method: 'PUT',
          };
        },
      }),

      createRole: build.mutation<CreateRoleResult, CreateRoleDTO>({
        query: (body) => {
          return {
            url: '/admin/v1/roles',
            method: 'POST',
            body,
          };
        },
      }),
    };
  },
});

export const {
  useGetMyAuthoritiesQuery,
  useLazyGetMyAuthoritiesQuery,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useDeleteUserMutation,
  useCreateUserMutation,
  useGetRolesQuery,
  useCreateRoleMutation,
  useGetAuthoritiesQuery,
  useDeleteRoleMutation,
  useGetRoleByIdQuery,
  useUpdateRoleMutation,
  useUpdateUserMutation,
} = adminRolesEndpoints;

export type AdminRolesController = typeof adminRolesEndpoints;
